export type Jaw = 'upper'|'lower'
export const JawTranslation = {
  upper: 'Oberkiefer',
  lower: 'Unterkiefer'
}
export const JawRouteNamespaces = {
  upper: 'oberkiefer',
  lower: 'unterkiefer'
}
